import { render, staticRenderFns } from "./CArticle.vue?vue&type=template&id=1ab09b1c&"
import script from "./CArticle.vue?vue&type=script&lang=js&"
export * from "./CArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports